module.exports = __webpack_public_path__ + "assets/images/animations/kfc-animation.png?b48fc6bc";